import { Chip } from '@mui/material';
export default function PaymentChip({ status = 'Not paid', ...props }) {
    const color = ['Paid', 'Overpaid', 'paid'].includes(status) ? 'success'
        : ['Partially paid', 'Refunded', 'Disputed', 'Needs review', 'preparing', 'draft'].includes(status) ? 'warning'
        : ['Not paid', 'Overdue', 'Payment failed', 'uncollectible'].includes(status) ? 'error' : 'default';
    const label = { open: 'Awaiting payment', paid: 'Paid', void: 'Voided', preparing: 'Preparing', draft: 'Draft', uncollectible: 'Uncollectible' }[status] || status;
    return <Chip role="status" variant="outlined" {...props} size="small" color={color} label={label} />;
}
